<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { ShieldCheck, Server, Terminal, Activity } from 'lucide-vue-next'
import Sidebar from './Sidebar.vue'

const route = useRoute()

// 是否需要显示侧边栏（登录页不显示）
const showSidebar = computed(() => {
  const noSidebarRoutes = ['/login']
  return !noSidebarRoutes.includes(route.path)
})
</script>

<template>
  <div class="min-h-screen bg-slate-50 text-slate-800 flex flex-col font-sans">
    <!-- 侧边栏 -->
    <Sidebar v-if="showSidebar" />

    <!-- 主内容区 -->
    <main
      class="flex-1 flex flex-col transition-all duration-300 min-w-0"
      :class="showSidebar ? 'ml-64' : 'ml-0'"
    >
      <!-- 顶部控制台导航栏 -->
      <header v-if="showSidebar" class="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-6 sticky top-0 z-40">
        <div class="flex items-center space-x-3">
          <h2 class="text-base font-semibold text-slate-800 tracking-tight">{{ route.meta.title || '网关管理' }}</h2>
          <span class="hidden sm:inline-block text-slate-300 font-light">/</span>
          <span class="hidden sm:inline-block text-xs font-mono text-slate-500 bg-slate-100 px-2 py-0.5 rounded border border-slate-200">PAY-EXT CONSOLE</span>
        </div>

        <div class="flex items-center space-x-4">
          <span class="text-xs font-mono text-slate-400">v1.2.0</span>
        </div>
      </header>

      <!-- 页面内容 -->
      <div :class="showSidebar ? 'flex-1' : ''">
        <router-view v-slot="{ Component }">
          <transition name="fade" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </div>
    </main>
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.fade-enter-from {
  opacity: 0;
  transform: translateY(4px);
}

.fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
</style>
